import * as React from 'react';
import { Card, Button, InputGroup, Form, Accordion } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './SettingsGeneral.scss';
import Field from '../../Shared/Wizard/Field/Field';

function SettingsInvoicing(props) {
    const t = useTranslate();  
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const [settings, setSettings] = useState(props.settingProps);
    
    async function handleSaveSettingsGeneral() {
        axios.put('/api/settings/' + settings["_id"], {
            confirmationTextSms: settings["confirmationTextSms"],
            confirmationTextEmail: settings["confirmationTextEmail"],
            invoicingValue: settings["invoicingValue"]
        }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            if (response.status == 200) {
                notifySuccess(t("settings.toast_savesuccess"));
            }
            if (props.onSettingsGeneralChanged != undefined) {
                props.onSettingsGeneralChanged(response.data);
            }
            
        });
    }

    useEffect(() => {
         setSettings(props.settingProps);
    }, [props]);

    return(
    <div>
        <Card>
            <Accordion.Toggle className="clickable" as={Card.Header} eventKey="5">
                <h4 className="header-title">{t("settings.invoicing.title")}</h4>
                <p>{t("settings.invoicing.description")}</p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="5">
                <Card.Body>
                    <p>{t("settings.invoicing.values.value.description")}</p>
                    <Field
                        title={t("settings.invoicing.values.value.title")}
                        type="input"
                        value={settings?.invoicingValue}
                        onChange={(val) => setSettings({...settings, invoicingValue: val})}
                    ></Field>
                    <Button className="savesettingsBtn savebtn" style={{ marginBottom: "20px" }} disabled={props.inheriting} onClick={handleSaveSettingsGeneral}>{props.inheriting ? t("settings.saveinherited") : t("settings.save")}</Button>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    </div>
       
    );
}
 
export default SettingsInvoicing;